export interface DataPrivacyPolicy {
  version: string;
  publishedDate: string;
  lastUpdated: string;
  title: string;
  sections: Section[];
}

export interface Section {
  title: string;
  subsections: Section[] | null;
  content: (TextContent | ListContent | ListEnumContent | AddressContent)[] | null;
}

export interface TextContent {
  type: ContentType.TEXT;
  body: string;
}

export interface ListContent {
  type: ContentType.LIST;
  content: TextContent[];
}

export interface ListEnumContent {
  type: ContentType.LIST_ENUM;
  content: TextContent[];
}

export interface AddressContent {
  type: ContentType.ADDRESS;
  organisation: string;
  street: string;
  zipCode: string;
  city: string;
  email: string;
  web: string;
}

export enum ContentType {
  ADDRESS = 'ADDRESS',
  TEXT = 'TEXT',
  LIST = 'LIST',
  LIST_ENUM = 'LIST-ENUM',
}
